import { render, staticRenderFns } from "./WithBackground.vue?vue&type=template&id=29c10554&scoped=true&"
import script from "./WithBackground.vue?vue&type=script&lang=js&"
export * from "./WithBackground.vue?vue&type=script&lang=js&"
import style0 from "./WithBackground.vue?vue&type=style&index=0&id=29c10554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c10554",
  null
  
)

export default component.exports